import { render, staticRenderFns } from "./sections.vue?vue&type=template&id=53d55856&scoped=true"
import script from "./sections.vue?vue&type=script&lang=js"
export * from "./sections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d55856",
  null
  
)

export default component.exports